module.exports = __webpack_public_path__ + "img/close.e51bac30.svg";